import React, { useEffect, useState } from 'react';
import { Table, Button, Row, Col, Switch, Tooltip, notification } from 'antd';
import { FaPlusCircle, FaPencilAlt } from "react-icons/fa";
import { getAllCategories, addCategory, updateCategory } from '../services/CategoriesService';

import CategoryModalNew from './CategoryModalNew';
import CategoryModalEdit from './CategoryModalEdit';

function Category(){
  const[dataCategories, setDataCategories] = useState([]);
  const[modalVisibleNew, setModalVisibleNew] = useState(false);
  const[modalVisibleEdit, setModalVisibleEdit] = useState(false);
  //const[urlThumbnail, setUrlThumbnail] = useState("");
  const[nameCategory, setNameCategory] = useState("");
  const[idCategory, setIdCategory] = useState("");
  const[activeCategory, setActiveCategory] = useState("");
  const[tableCategoryLoading, setTableCategoryLoading] = useState(false);

  //const origin = window.location.origin;

    useEffect(() => {
      setTableCategoryLoading(true);
        async function process(){
          const { data } = await getAllCategories();
          setDataCategories(data);
          setTableCategoryLoading(false);
        }
        process();
        
    },[])

    const msNotification = (type, title, desc) => {
      notification[type]({
        message: title,
        description:
          desc,
      });
    };

    const onChangeActive = (record, checked) => {
      const requestCategory = {
        "id": record.id,
        "name": record.name,
        "active": checked
      };
      async function updateTheCategory(){
        try {
            await updateCategory(record.id, requestCategory);  
            const dataCat = [...dataCategories]
            dataCat.find(x => x.id === record.id).active = checked;
            setDataCategories(dataCat); 
            msNotification('success', 'Categoría', 'Se actualizó la categoría.' );
        } catch (error) {
          msNotification('error', 'Categoría', 'Error al actualizar la categoría.' );
        } finally {
            //setUploading(false);
        }
      }
      updateTheCategory();
    }

    const handleClickModalNew = () => {
      setModalVisibleNew(true);
    }

    const handleClickModalEdit = (record) => {
      setNameCategory(record.name);
      //setUrlThumbnail(record.uriThumbnail);
      setIdCategory(record.id);
      setActiveCategory(record.active)
      setModalVisibleEdit(true);
    }

    const handleOkModalNew = (data) =>{
      // var dataimg = data.image == null ? null : {
      //   "Name": data.name,
      //   "Position": 0,
      //   "MediaType": data.mediaType,
      //   "ImageContent": data.image
      // };
      
      const request = {
        "Name": data.categoryName,
        "Active": true
        //"Images": dataimg
      };
      async function addNewCategory(){
          try {
              const { data } = await addCategory(request);
              const tempCategories = [...dataCategories];
              tempCategories.push(data);
              setDataCategories(tempCategories);
              msNotification('success', 'Categoría', 'Se creó la categoría.' );
          } catch (error) {
            msNotification('error', 'Categoría', 'Error al crear la categoría.' );
          } finally {
            setModalVisibleNew(false);
          }
      }
      addNewCategory();

    }

    const handleCancelModalNew = () =>{
      setModalVisibleNew(false);
    }

    const handleOkModalEdit = (tipo, datac) =>{
      const requestCategory = {
        'id': idCategory,
        'name': datac.categoryName,
        'active': activeCategory
      };
      // const requestImage = {
      //   'customerId': customerId,
      //   'organizationId': organizationId,
      //   'id': idCategory,
      //   'name': datac.name,
      //   'position': 0,
      //   'mediaType': datac.mediaType,
      //   'imageContent': datac.image
      // }
      async function updateTheCategory(){
          try {
              await updateCategory(idCategory, requestCategory);   
              const dataCat = [...dataCategories]
              dataCat.find(x => x.id === idCategory).name = datac.categoryName;
              setDataCategories(dataCat); 
              msNotification('success', 'Categoría', 'Se actualizó la descripción de la categoría.' );
          } catch (error) {
            msNotification('error', 'Categoría', 'Error al actualizar la descripción de la categoría.' );
          } finally {
            setModalVisibleEdit(false);
          }
      }
      // async function updateImageCategory(){
      //   try {
      //     const { data } = await updateCategoryImage(idCategory, requestImage);
      //     const dataCat = [...dataCategories];
      //     dataCat.find(x => x.id === idCategory).uriThumbnail = data.image.urlThumbnail;
      //     setDataCategories(dataCat);
      //     msNotification('success', 'Categoría', 'Se actualizó la imagen de la categoría.' );
      //   } catch (error) {
      //     msNotification('error', 'Categoría', 'Error al actualizar la imagen de la categoría.' );
      //   } finally {
      //     setModalVisibleEdit(false);
      //   }
      // }
      if(tipo === 1){
        if(datac.categoryName !== nameCategory && datac.categoryName !== ""){
          updateTheCategory();
        }
          
      }
      // if(tipo === 2){
      //   updateImageCategory();
      //   if(datac.categoryName !== nameCategory && datac.categoryName !== ""){
      //     updateTheCategory();
      //   }
      // }
      
    }

    const handleCancelModalEdit = () =>{
      setModalVisibleEdit(false);
    }

    const columns = [
      {
        title: "Información",
        render: (record) => (
          <React.Fragment>
            {record.id}
            <br />
            {record.name}
          </React.Fragment>
        ),
        responsive: ["xs"]
      },
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        responsive: ["sm"]
      },
      {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name',
        responsive: ["sm"]
      },
      // {
      //   title: '',
      //   dataIndex: 'uriThumbnail',
      //   align: 'center',
      //   key: 'uriThumbnail',
      //   render: (value) => ( value !== null ? <img className='imgTable' src={origin + value} /> : "")
      // },
      {
        title: '',
        dataIndex: 'active',
        align: 'center',
        key: 'active',
        render: (value, record) => (<Switch checked={value} onChange={(checked) => onChangeActive(record, checked)} />)
      },
      {
        title: '',
        align: 'center',
        render: (value, record) => (<Tooltip title="Editar">
            <Button type="primary" shape="circle" onClick={() => handleClickModalEdit(record)} icon={<FaPencilAlt />} />
          </Tooltip>)
      },
    ];

    return(
        <div className="mainContainer">

            <CategoryModalNew modalVisibleNew={modalVisibleNew} 
              handleCancelModalNew={handleCancelModalNew}
              handleOkModalNew={handleOkModalNew}/>

            <CategoryModalEdit modalVisibleEdit={modalVisibleEdit} 
              handleCancelModalEdit={handleCancelModalEdit}
              handleOkModalEdit={handleOkModalEdit}
              //urlThumbnail={urlThumbnail}
              nameCategory={nameCategory}
              idCategory={idCategory}/>

            <Row>
                <Col span={24}>
                    <h1 className="title">Categorías</h1>
                    <hr className="hr-title"/>
                </Col>
            </Row>

            <Row className="detailContainer">
                <Col span={24}>
                    <div className="divRight">
                        <Button type="primary" icon={<FaPlusCircle/>} onClick={handleClickModalNew}>
                          &nbsp; Nueva
                        </Button>
                    </div>
                </Col>
                <Col span={24}>
                    <br/>
                    <Table rowKey="id" dataSource={dataCategories} columns={columns} loading={tableCategoryLoading}/>
                </Col>
            </Row>

        </div>
    );
}

export default Category;



// WEBPACK FOOTER //
// ./src/components/Category.jsx